import React, { useEffect } from 'react';
import { NavHub, Title4 } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { trackGAEvent } from '../../../utils/gaTracking';
import { ATTRIBUTE_VALUES } from '../../../../../constants/attributes';

import Classes from './HubList.module.scss';
import { TContentItem } from 'types/TContentArticles';

type HubListProps = {
  content: {
    key: string;
    items: TContentItem[];
  };
  isLeasePage: boolean;
};

const HubList = ({ content, isLeasePage }: HubListProps) => {
  const { t } = useI18nContext();
  const priceTypeAttribute = isLeasePage ? ATTRIBUTE_VALUES.PRICE_TYPE.LEASE : '';

  useEffect(() => {
    trackGAEvent('Displayed', `${content.key}_carousel`);
  }, [content.key]);

  const onCLickHandler = (index: number) => {
    trackGAEvent('Clicked', content.key, index);
  };

  return (
    <div className="PageContent-offset">
      <Title4 utilities={['marginTopS', 'marginBottomS']}>{t(`cars.carousel.title.${content.key}`)}</Title4>
      <div className={Classes.root}>
        {content.items.map(({ key, link, images, data }, indexOfItem) => (
          <NavHub
            key={key}
            className={Classes.item}
            href={`${link}${priceTypeAttribute}`}
            onClick={() => onCLickHandler(indexOfItem)}
            bodyTitle={t(`cars.carousels.items.${key}.title`)}
            bodyDescription={t(`cars.carousels.items.${key}.subtitle`, { count: data?.count })}
            isParent
            imageLoading="lazy"
            decoding="async"
            fetchPriority="low"
            alt={t(`cars.carousels.items.${key}.alt`)}
            aspectRatio={content.key === 'popular-brands' ? 'square' : 'landscape'}
            imageSrc={images[0]}
          />
        ))}
      </div>
    </div>
  );
};

export default HubList;
